// Copyright (c) Docugami, Inc. All rights reserved.

import { createSelector } from "@reduxjs/toolkit";
import { AppState } from "store";
import { ChatOptions, SystemTextChatMessage, isSystemMessage } from "./chatApi";
import { chatApi, selectAllChatHistory } from "./chatSlice";
import { FeatureFlags } from "store/featureFlags/types";

export const createSelectChatOptions = () => createSelector(
    [
        (state: AppState, docSetId: string) => docSetId,
        (state: AppState) => state.featureFlags.featureFlags[FeatureFlags.ChatFeature],
    ],
    (docSetId: string, chatEnabled): ChatOptions | null => {
        if (!chatEnabled) {
            return null;
        }

        return {
            docsetId: docSetId
        };
    }
);

export const createSelectChatMessageResponse = () => createSelector(
    [
        (state: AppState, chatOptions?: ChatOptions, messageId?: string) => chatOptions ? chatApi.endpoints.initializeDocSetChat.select(chatOptions)(state).data?.chatHistory : undefined,
        (state: AppState, chatOptions?: ChatOptions, messageId?: string) => messageId,
    ],
    (chatHistory, messageId): SystemTextChatMessage | undefined => {
        if (!chatHistory || !messageId) {
            return;
        }

        return selectAllChatHistory(chatHistory).find(x => isSystemMessage(x) && x.parentId === messageId) as SystemTextChatMessage;
    }
)

export const createSelectHasSessionMessages = () => createSelector(
    [
        (state: AppState, chatOptions: ChatOptions | null, sessionId: string | undefined) => chatOptions ? chatApi.endpoints.initializeDocSetChat.select(chatOptions)(state).data?.chatHistory : undefined,
        (state: AppState, chatOptions: ChatOptions | null, sessionId: string | undefined) => sessionId,
    ],
    (chatHistory, sessionId): boolean => {
        if (!chatHistory) {
            return false;
        }

        return !!selectAllChatHistory(chatHistory).find(x => x.sessionId === sessionId);
    }
)
